"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetActions200ResponseToJSON = exports.GetActions200ResponseFromJSONTyped = exports.GetActions200ResponseFromJSON = exports.instanceOfGetActions200Response = void 0;
var runtime_1 = require("../runtime");
var Action_1 = require("./Action");
/**
 * Check if a given object implements the GetActions200Response interface.
 */
function instanceOfGetActions200Response(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfGetActions200Response = instanceOfGetActions200Response;
function GetActions200ResponseFromJSON(json) {
    return GetActions200ResponseFromJSONTyped(json, false);
}
exports.GetActions200ResponseFromJSON = GetActions200ResponseFromJSON;
function GetActions200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'data': !(0, runtime_1.exists)(json, 'data') ? undefined : (json['data'].map(Action_1.ActionFromJSON)),
    };
}
exports.GetActions200ResponseFromJSONTyped = GetActions200ResponseFromJSONTyped;
function GetActions200ResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'data': value.data === undefined ? undefined : (value.data.map(Action_1.ActionToJSON)),
    };
}
exports.GetActions200ResponseToJSON = GetActions200ResponseToJSON;
